import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { ResponseDto } from '@r1-frontend/api-domru/api-tariffs/v1/address/check/dto/ResponseDto';
import { IContactAddress } from '@r1-frontend/entities/ContactAddress/initialState';
import { TPersonData } from '@r1-frontend/entities/ContactDetail/initialState';

import { TReturnType } from '@r1-frontend/service-engineer-visit';

import { EBonusTypes } from '~/src/features/full-buy/PromoCode';
import { TProduct } from '~/src/features/full-buy/store/transformShopItem';
import { ESteps } from '~/src/features/full-buy/types';

import { IFullBuyTariff } from './tariffTransformer';

export enum ESpecialTariffLine {
    allTariffPackages = 'allTariffPackages',
}

export enum ETariffFilters {
    KP = 'kp',
    MONO = 'mono',
    SPEED100 = 'speed100',
    SPEED_LESS_1000 = 'less1000',
    COTTAGE = 'cottage',
}

export interface IPromoCode {
    value?: string,
    amount?: string | number,
    type?: EBonusTypes,
    hasError?: boolean,
    dealerUid?: number | undefined,
}

export interface IAgreementData {
    agreementId: number | null,
    agreementNumber: number | null,
    isDouble: boolean,
    hasError: boolean,
    errorMessage: string,
}

export interface ISelectedTariffParamsById {
    salePackageId: number,
}

export interface ISelectedTariffParamsByAlias {
    tariffNameAlias: string,
    monoTariff: boolean,
}

export interface IFlow {
    name: string,
    steps: ESteps[],
}

export type TConnectionPrice = {
    base?: number,
    withDiscount?: number,
} | null


export type TSubscription = {
    id: number,
    serviceId: number,
    title: string,
    description: string,
    fullDescription: string,
    fullDescriptionList: string[],
    price: { base: number, discount: number },
    images: { mobile: string, desktop: string, popup: string },
    type: 'oneOf' | 'multiple',
}

export type TUnifiedAddress = {
    value: string,
    flat: string,
    companyId?: number,
    unifiedHouseId?: number,
}

export type TUnifiedAddressData = {
    address: TUnifiedAddress,
    isConnectionAvailable: boolean,
    isTariffAvailable: boolean,
    checkingResult?: ResponseDto,
}

export type TFullBuyData = {
    initialized: boolean,
    _displayTariffLine: boolean,
    _addressVerificationOnFirstStep: boolean,
    _backgroundLoading: boolean,
    isShownLoader: boolean,
    isRequestCreatingFailed: boolean,

    tariffs: IFullBuyTariff[],
    products: TProduct[],
    subscriptions: Record<number, { oneOf: number[], items: TSubscription[] }>,

    selectedSubscriptions: number[],
    calculatedSalePackageId: number | null,

    tariffLineAlias: string | ESpecialTariffLine,

    filters: ETariffFilters[],
    selectedTariff: ISelectedTariffParamsById | ISelectedTariffParamsByAlias | null,
    promoCode: IPromoCode | null,
    flow: IFlow | null,
    stepIndex: number,
    prevStepIndex: number,
    slot: TReturnType | null,
    agreement: IAgreementData,

    selectedAddress?: TUnifiedAddressData,
};

// @todo rename to the TFullBuyState or TFullBuyStore
export const initialState: TFullBuyData = {
    initialized: false,
    _displayTariffLine: false,
    _addressVerificationOnFirstStep: false,
    isShownLoader: false,
    isRequestCreatingFailed: false,

    _backgroundLoading: false,

    tariffs: [],
    products: [],

    subscriptions: [],
    selectedSubscriptions: [],
    calculatedSalePackageId: null,

    tariffLineAlias: '',
    filters: [],
    selectedTariff: null,
    promoCode: null,
    flow: null,
    stepIndex: 0,
    prevStepIndex: 0,
    slot: null,
    agreement: {
        agreementId: null,
        agreementNumber: null,
        isDouble: false,
        hasError: false,
        errorMessage: '',
    },

    selectedAddress: undefined,
};

export interface IFullBuyState {
    fullBuy: TFullBuyData,
    contactAddress: IContactAddress,
    contactDetails: TPersonData,
}

export type FullBuyGetState = () => IFullBuyState;

export type TFullBuyThunkDispatch = ThunkDispatch<IFullBuyState, void, AnyAction>;
